// import { call, put, takeEvery } from "redux-saga/effects";
// import {
//     fetchChatSessionsRequest,
//     fetchChatSessionsSuccess,
//     fetchChatSessionsFailure,
// } from "../slice/chatSessionHistorySlice";
// import { fetchChatSessionsApi } from "@src/api/apiService";
// // Saga function
// function* fetchChatSessions(): Generator<any, void, any> {
//     try {
//         const response = yield call(fetchChatSessionsApi);
//         yield put(fetchChatSessionsSuccess(response.data));
//     } catch (error: any) {
//         yield put(fetchChatSessionsFailure(error?.response?.data?.detail || error.message || "Unknown error"));
//     }
// }

// // Watcher saga
// export function* chatSessionHistorySaga() {
//     yield takeEvery(fetchChatSessionsRequest.type, fetchChatSessions);
// }
import { call, put, takeLatest } from 'redux-saga/effects';
import { getApiError } from "@src/utils/apiError";
import {
  fetchChatSessionsRequest,
  fetchChatSessionsSuccess,
  fetchChatSessionsFailure,
} from '../slice/chatSessionHistorySlice';
import { fetchChatSessionsApi } from '../../api/apiService';

export function* fetchChatSessions(
  action: ReturnType<typeof fetchChatSessionsRequest>
): Generator<any, void, any> {
  try {
    const { offset, limit, search, partnerProjectId } = action.payload;

    const response = yield call(
      fetchChatSessionsApi,
      offset,
      limit,
      search,
      partnerProjectId
    );

    yield put(
      fetchChatSessionsSuccess({
        ...response.data,
        offset,
        search,
      })
    );
  } catch (error: unknown) {
    const apiError = getApiError(error);

    yield put(
        fetchChatSessionsFailure(
            apiError.message
        )
    );
  }
}

export function* chatSessionHistorySaga() {
  // ✅ prevents race conditions (same as bookmarks)
  yield takeLatest(fetchChatSessionsRequest.type, fetchChatSessions);
}